// 統計數字（關注者／訂閱者等）的顯示格式
//
// 一千以上縮寫成 K / M / B（1,000 → 1K），與 YouTube / TikTok 的計數顯示一致；
// 未滿一千直接顯示原始數字，不會出現千分位（用不到）。
//
// 小數一律無條件捨去而非四捨五入，顯示值才不會大於實際值（1,999 → 1.9K，不是 2K）。
// 結尾的 .0 會去掉（1,000 → 1K）。
const UNITS = [
    { value: 1e9, suffix: 'B' },
    { value: 1e6, suffix: 'M' },
    { value: 1e3, suffix: 'K' },
];

export const formatCount = (count) => {
    // 找不到對應單位 = 未滿一千，原樣顯示
    const unit = UNITS.find((item) => count >= item.value);
    if (!unit) return String(count);

    const scaled = Math.floor((count / unit.value) * 10) / 10;
    return `${scaled}${unit.suffix}`;
};
